import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('numa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normaliza el mensaje de error para mostrarlo directo en la UI
export function mensajeDeError(err) {
  return err?.response?.data?.error || 'Ocurrió un error. Intenta de nuevo.';
}

export default client;
